import { useRequestGetDashboardData } from '@/hooks/httpRequest';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui';
import { useDocumentTitle, useListenEvents } from '@/hooks';
import { BadgeCounter } from '@/components/custom';
import { useEffect, useState } from 'react';
import { useUrlParams } from '../hooks';
import { cn } from '@/lib/utils';
import { TTabname } from '..';

interface IState {
  countVerifiers: number;
  countUsers: number;
}

const CONSTS = {
  initState: {
    countVerifiers: 0,
    countUsers: 0
  } as IState
}

const TabMenus = () => {

  const [state, setState] = useState<IState>(CONSTS.initState);
  const { data } = useRequestGetDashboardData();
  const { changeTab, tab } = useUrlParams();
  useDocumentTitle({
    title: (
      tab === 'users'
        ? 'Signalements des utilisateurs'
        : 'Signalements des vérificateurs'
    )
  });

  useListenEvents({
    type: 'photosVerified',
    callback: () => setState(l => ({ ...l, countVerifiers: Math.max(0, (l.countVerifiers - 1)) }))
  });

  useListenEvents({
    type: 'profileCertified',
    callback: () => setState(l => ({ ...l, countVerifiers: Math.max(0, (l.countVerifiers - 1)) }))
  });

  useListenEvents({
    type: 'userBanned',
    callback: () => setState(l => ({ ...l, countUsers: Math.max(0, (l.countUsers - 1)) }))
  });

  useListenEvents({
    type: 'userWarned',
    callback: () => setState(l => ({ ...l, countUsers: Math.max(0, (l.countUsers - 1)) }))
  });

  useListenEvents({
    type: 'reportIgnored',
    callback: () => setState(l => ({ ...l, countUsers: Math.max(0, (l.countUsers - 1)) }))
  });

  useEffect(
    () => {
      setState(
        l => ({
          ...l,
          countVerifiers: ((data?.review?.photo ?? 0) + (data?.review?.id ?? 0)),
          countUsers: data?.reports ?? 0
        })
      );
    },
    [data?.review, data?.reports]
  );

  return (
    <Tabs
      className='pt-3 md:pt-5'
      onValueChange={changeTab}
      value={tab} >
      <TabsList className={cn(
        'w-full flex justify-center',
        'md:w-auto md:inline-flex'
      )}>
        <TabsTrigger
          title='Signalements émis par nos utilisateurs'
          className='flex items-center space-x-2'
          value={'users' as TTabname}>
          <BadgeCounter
            isActive={tab === 'users'}
            count={state.countUsers} />
          <span>
            Utilisateurs
          </span>
        </TabsTrigger>
        <TabsTrigger
          title='Signalements émis par les vérificateurs'
          className='flex items-center space-x-2'
          value={'verifiers' as TTabname}>
          <BadgeCounter
            count={state.countVerifiers}
            isActive={tab === 'verifiers'} />
          <span>
            Vérificateurs
          </span>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );

};

export default TabMenus;
